import { TransportEnum } from '@repo/utils'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import { CarbonFootprintMealTypeFieldProps } from '../CarbonFootprintForm'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../../../../../shadcn/components/ui/form'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../../../shadcn/components/ui/select'

const CarbonFootprintTransportModeField = ({
  form,
}: CarbonFootprintMealTypeFieldProps) => {
  return (
    <FormField
      control={form.control}
      name='transportMode'
      render={({ field, fieldState }) => (
        <FormItem>
          <FormLabel className='font-normal'>
            <FormattedMessage
              id='ui.CarbonFootprintTransportModeField.label'
              defaultMessage='Mode de transport'
            />
          </FormLabel>
          <FormControl>
            <Select
              onValueChange={(value) => field.onChange(value)}
              defaultValue={field.value}
            >
              <SelectTrigger error={fieldState.error}>
                <SelectValue
                  placeholder={
                    <FormattedMessage
                      id='ui.CarbonFootprintTransportModeField.placeholder'
                      defaultMessage='Sélectionnez'
                    />
                  }
                />
              </SelectTrigger>
              <SelectContent>
                {transportModeOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
      rules={{ required: true }}
    />
  )
}

export default CarbonFootprintTransportModeField

const transportModeOptions = [
  {
    label: (
      <FormattedMessage
        id='ui.CarbonFootprintTransportModeField.option.thermalCar'
        defaultMessage='Voiture thermique'
      />
    ),
    value: TransportEnum.THERMAL_CAR,
  },
  {
    label: (
      <FormattedMessage
        id='ui.CarbonFootprintTransportModeField.option.electricCar'
        defaultMessage='Voiture électrique'
      />
    ),
    value: TransportEnum.ELECTRIC_CAR,
  },
  {
    label: (
      <FormattedMessage
        id='ui.CarbonFootprintTransportModeField.option.train'
        defaultMessage='Train'
      />
    ),
    value: TransportEnum.TRAIN,
  },
  {
    label: (
      <FormattedMessage
        id='ui.CarbonFootprintTransportModeField.option.bus'
        defaultMessage='Bus'
      />
    ),
    value: TransportEnum.BUS,
  },
  {
    label: (
      <FormattedMessage
        id='ui.CarbonFootprintTransportModeField.option.plane'
        defaultMessage='Avion'
      />
    ),
    value: TransportEnum.PLANE,
  },
]
